import React, { useEffect, useState } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import UploadFile from "../../Components/UploadFile/UploadFile";
import { Spinner } from "../../Components/Spinner/Spinner";
import projectSettings from "../../assets/Js/projectSettings";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { callAPI } from "../../assets/Js/backendCommunication";
import { closeModel } from "../../assets/Js/closeModel";
import { immediateToast } from "izitoast-react";
import { chatGroupEnum } from "../../assets/Js/chatGroupEnum";

export default function CreateCustomGroup({
  allAthletesData,
  handleUserSelection,
  goToPrevScreen,
  goToNextScreen,
  groupContainerStyle,
  aditionalProps,
  modalId,
  resetModalInfo,
  getNewChats,
}) {
  const [userOptions, setUserOptions] = useState([]);
  const [groupProfileImage, setGroupProfileImage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDesciption] = useState("");
  const [userIds, setUserIds] = useState([]);

  useEffect(() => {
    if (aditionalProps?.GroupInfo) {
      setGroupName(aditionalProps.GroupInfo.GroupName);
      setGroupDesciption(aditionalProps.GroupInfo.Description);
    } else {
      createOptionsForSelection();
    }
  }, []);

  useEffect(() => {
    if (aditionalProps?.GroupInfo) {
      setGroupName(aditionalProps.GroupInfo.GroupName);
      setGroupDesciption(aditionalProps.GroupInfo.Description);
    }
  }, [aditionalProps]);

  useEffect(() => {
    createOptionsForSelection();
  }, [allAthletesData]);

  const createOptionsForSelection = () => {
    let _allAthletes = allAthletesData;
    let _athleteWhoHaveNotJoinnedGroup = _allAthletes;

    if (aditionalProps?.AllMembersOfGroup?.length) {
      _athleteWhoHaveNotJoinnedGroup = _allAthletes.filter(
        (user) =>
          !aditionalProps.AllMembersOfGroup.some(
            (eachGroupMember) => eachGroupMember.Id === user.id
          )
      );
    }

    let _userOptions = _athleteWhoHaveNotJoinnedGroup.map((eachAthlete) => ({
      value: `${eachAthlete.FirstName} ${eachAthlete.LastName}`,
      label: `${eachAthlete.FirstName} ${eachAthlete.LastName}`,
      id: eachAthlete.Id,
      image: eachAthlete.Image,
      gender: eachAthlete.Gender,
      email: eachAthlete.Email,
    }));

    setUserOptions(_userOptions);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    createNewGroup();
  };

  const createNewGroup = async () => {
    let _groupId = aditionalProps?.GroupInfo?.GroupId || undefined;
    let endpoint = _groupId
      ? `/customGroup/update/${_groupId}`
      : `/createCustomGroup`;

    let url = `${projectSettings.baseUrl}/chats${endpoint}`;
    let header = false;
    let type = "POST";
    let token = getPlainToken();
    let data = new FormData();
    let response = "";

    if ((!_groupId && userIds.length) || _groupId) {
      data.append("GroupName", groupName);
      data.append("GroupDescription", groupDescription);
      data.append("GroupImage", groupProfileImage);

      data.append("Users", JSON.stringify(userIds));

      if (response === "") {
        setIsLoading(true);
      }

      response = await callAPI(url, header, type, data, token);

      if (response) {
        let { status, data, message } = response;

        setIsLoading(false);

        if (response.data.StatusCode === 200) {
          let { groupId, groupImage, groupName } = data.Result;
          let userId = groupId;

          handleUserSelection({
            userId,
            groupId,
            UserName: groupName,
            image: groupImage,
            groupType: chatGroupEnum.CustomGroup,
            isGroup: false,
          });

          // getNewChats();

          if (modalId) {
            closeModel(modalId);
            if (resetModalInfo && typeof resetModalInfo === "function") {
              resetModalInfo();
            }
          }
        } else {
          data?.Errors?.length &&
            immediateToast("warning", { message: data.Errors[0] });
        }
      }
    } else if (!_groupId) {
      immediateToast("warning", {
        message: "Please! Select a user",
      });
    }
  };

  const saveGroupName = (e) => {
    setGroupName(e.target.value);
  };

  const saveGroupDesciption = (e) => {
    setGroupDesciption(e.target.value);
  };

  const saveSelectedUsers = (selectedOptions) => {
    let _selectedUserIds = selectedOptions.map((eachUser) => eachUser.id);

    setUserIds(_selectedUserIds);
  };

  return (
    <form onSubmit={submitHandler} className={groupContainerStyle}>
      <div className="fromGroup mb-2">
        <UploadFile
          defaultImage={aditionalProps?.GroupInfo?.GroupImage}
          setGroupProfileImage={setGroupProfileImage}
        />
      </div>

      <div className="formGroup">
        <div className="mr-1">
          <label htmlFor="firstName">Group Name</label>
          <input
            type="text"
            className="form-control form-control-sm"
            id="groupName"
            placeholder="Enter Group Name"
            maxLength="25"
            required
            defaultValue={groupName}
            onChange={saveGroupName}
          />
        </div>
      </div>

      <div class="formGroup">
        <label for="exampleFormControlTextarea1">Description</label>
        <textarea
          class="form-control form-control-sm"
          id="exampleFormControlTextarea1"
          rows="3"
          placeholder="Your description should be less than 250 characters"
          required
          defaultValue={groupDescription}
          maxLength={250}
          onChange={saveGroupDesciption}
        ></textarea>
      </div>

      <label for="exampleFormControlTextarea1">Select Participants</label>
      <Select
        closeMenuOnSelect={false}
        options={userOptions}
        isMulti={true}
        onChange={saveSelectedUsers}
      />
      <div className="mx-auto width-fit-content mt-2 mb-2">
        <button className="basicBtnStyle primaryBtn" disabled={isLoading}>
          {isLoading ? (
            <Spinner />
          ) : (
            <span>
              {aditionalProps?.GroupInfo?.GroupName ? "Update" : "Create"}
            </span>
          )}
        </button>
      </div>
    </form>
  );
}

CreateCustomGroup.proptTypes = {
  allAthletesData: PropTypes.array,
  modalId: PropTypes.string,
  handleUserSelection: PropTypes.func,
  goToPrevScreen: PropTypes.func,
  goToNextScreen: PropTypes.func,
  groupContainerStyle: PropTypes.string,
  aditionalProps: PropTypes.object,
};
